import React from 'react';
import {ToggleItem} from './toggleItem';
import PropTypes from 'prop-types'

class ToggleGroup extends React.Component {

	constructor(props, context) {
    	super(props, context);
	}

  handleClick(id, event, enabled) {

    this.props.clickItemHandler(id, enabled);
  }
  generateListItem(listitems) {
    
  	var n = 0;
  	
  	return listitems.map(function(item) {

  		return (
        <div key={n++}>
          <ToggleItem
            name={item.name} active={item.active} handleClick={this.handleClick.bind(this, item.id)} />
        </div>
      );
  	}.bind(this));
  }

  render() {

    return (
      <div style={{padding:'10px 10px 0 10px'}}>
        <div style={{fontSize:'14px'}}><p>{this.props.name}</p></div>
        {this.generateListItem(this.props.menuItems)}
        {(typeof this.props.children !== 'undefined' ? this.props.children : '')}
      </div>
    );
  }
}

ToggleGroup.propTypes = {
    name: PropTypes.string,
    clickItemHandler: PropTypes.func,
    menuItems: PropTypes.array
};

export {ToggleGroup}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/togglegroup/index.js